/* unplugin-vue-components disabled */import { render } from "./StatusCom.vue?vue&type=template&id=3e2338f3&scoped=true&lang=pug"
import script from "./StatusCom.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusCom.vue?vue&type=script&setup=true&lang=js"

import "./StatusCom.vue?vue&type=style&index=0&id=3e2338f3&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2338f3"]])

export default __exports__